import { createContext, use } from 'react';

const WorkspaceContext = createContext<WorkspaceContextType>({
    isOrganizationPending: false,
    isViewingOrg: false,
    isViewingProject: false,
    organizationSocket: undefined,
    projectSocket: undefined,
    refetchOrganization(): void {},
    refetchProject(): void {},
    refetchProjects(): void {},
});

const useWorkspace = () => {
    return use(WorkspaceContext);
};

export default WorkspaceContext;
export { useWorkspace };
